import Container from "Components/Container/Container";
import { useState, useEffect } from "react";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch.js";

const Team = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("our-team");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="scroll-section-special">
        <Container>
          <div className="flex flex-col lg:items-center lg:text-center pt-36 lg:pt-60">
            <h2 className="text-font text-3xl uppercase">{data?.title}</h2>
            <h1 className="bebas text-font text-5xl  sm:text-6xl md:text-7xl lg:text-8xl">
              {data?.sub_title}
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-14 mb-secondary lg:mb-primary gap-16 xl:gap-10 xxl:gap-16 map">
            {data?.team?.map(
              ({ image, name, position, description }, index) => (
                <div key={index} className="text-white">
                  <div className="h-[450px] w-full">
                    <img
                      src={image}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="block capitalize my-3 lg:my-4">
                    <p className="text-2xl mb-1 font-medium">{name}</p>
                    <p className="text-xl">{position}</p>
                  </span>
                  <div
                    className="text-lg"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>
              )
            )}
          </div>
        </Container>
      </main>
    );
  }
};

export default Team;
